// =============================================================================
// SEVRIC Battery Care — widget registry.
// =============================================================================
import { AISurfacesWidget }     from "../widgets/AISurfacesWidget.jsx";
import { AtRiskUnitsWidget }    from "../widgets/AtRiskUnitsWidget.jsx";
import { RecentCheckInsWidget } from "../widgets/RecentCheckInsWidget.jsx";
import { UnitHistorianWidget }  from "../widgets/UnitHistorianWidget.jsx";
import { MessagesWidget }       from "../widgets/MessagesWidget.jsx";
import { WeatherWidget }        from "../widgets/WeatherWidget.jsx";

export const WIDGETS = {
  "ai-surfaces": {
    id: "ai-surfaces",
    Component: AISurfacesWidget,
    label: "SEVRIC AI surfaces",
    description: "Three things worth seeing first — refreshed every morning.",
    icon: <Icon path="M12 2v3M12 19v3M4 12H1M23 12h-3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8z" />,
    defaultW: 12, defaultH: 5, minW: 6, minH: 4,
    category: "Overview",
  },
  "at-risk": {
    id: "at-risk",
    Component: AtRiskUnitsWidget,
    label: "Units that need eyes",
    description: "At-risk + watch + stale, ranked. One click into the check-in.",
    icon: <Icon path="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01" />,
    defaultW: 8, defaultH: 8, minW: 6, minH: 5,
    category: "Operations",
  },
  "recent-checks": {
    id: "recent-checks",
    Component: RecentCheckInsWidget,
    label: "Ops log",
    description: "Every reading, every action, live.",
    icon: <Icon path="M12 8v4l3 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" />,
    defaultW: 4, defaultH: 8, minW: 3, minH: 4,
    category: "Operations",
  },
  "historian-preview": {
    id: "historian-preview",
    Component: UnitHistorianWidget,
    label: "Unit historian preview",
    description: "The unit you touched last — its voltage story.",
    icon: <Icon path="M3 3v18h18M7 14l4-4 4 4 5-6" />,
    defaultW: 6, defaultH: 7, minW: 4, minH: 5,
    category: "Overview",
  },
  "messages": {
    id: "messages",
    Component: MessagesWidget,
    label: "Messages pinned to units",
    description: "Notes attached to a unit so context lives with the car.",
    icon: <Icon path="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />,
    defaultW: 6, defaultH: 7, minW: 4, minH: 4,
    category: "Personal",
  },
  "weather": {
    id: "weather",
    Component: WeatherWidget,
    label: "Today's weather",
    description: "Conditions at the lot — affects voltage decisions on cold mornings.",
    icon: <Icon path="M17 14a4 4 0 0 0 .88-7.9 6 6 0 0 0-11.74 1.05A4 4 0 0 0 7 14" />,
    defaultW: 4, defaultH: 4, minW: 3, minH: 3,
    category: "Personal",
  },
};

export function getWidget(id) { return WIDGETS[id] || null; }
export function listWidgets() { return Object.values(WIDGETS); }
export function widgetsByCategory() {
  const by = {};
  for (const w of Object.values(WIDGETS)) {
    if (!by[w.category]) by[w.category] = [];
    by[w.category].push(w);
  }
  return by;
}

function Icon({ path }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={path} />
    </svg>
  );
}
